var data = { header:{ text:"#### Error",
    closeButton:true },
  body:{ text:"{{@if(it.message.length > 0)}}\n  {{it.message}}\n{{#else}}\n  Server error was detected. Please try again or contact Client Services for assistance.\n{{/if}}",
    postProcessingAction:"processDefaultValidationError" },
  buttons:[ { text:"OK",
      isPrimary:true } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=default_validation_error.esm.js.map
